import { formatIndianCurrency, formatPLCRate } from '../../shared/utils/CurrencyFormat';
import DateFormat from './DateFormat';
import { capitaliseData } from './splitData';

/** Parse money cells: raw numbers, or strings like "₹1,234" / already-formatted. */
function toFiniteMoneyNumber(value) {
  if (value == null || value === '') return null;
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }
  const s = String(value).trim();
  // Plain numeric string (Postgres decimals arrive as "250000.00") — must keep
  // the decimal point. The old cleanup stripped "." and showed ×100 amounts.
  const direct = Number(s);
  if (Number.isFinite(direct)) return direct;
  const cleaned = s
    .replace(/INR/gi, '')
    .replace(/Rs\.?/gi, '')
    .replace(/[₹,\s]/g, '')
    .trim();
  if (cleaned === '' || cleaned === '-') return null;
  const n = Number(cleaned);
  return Number.isFinite(n) ? n : null;
}

export function transformData(data, format) {
  let transformedData = {};
  format.forEach((item) => {
    if (item === 'actions') {
      transformedData[item] = 'Actions';
    } else if (Object.prototype.hasOwnProperty.call(data, item)) {
      transformedData[item] = data?.[item];
    }
    if (item === 'brandList') {
      transformedData[item] = 'BrandList';
    } else if (Object.prototype.hasOwnProperty.call(data, item)) {
      transformedData[item] = data?.[item];
    }
    if (item === 'itemList') {
      transformedData[item] = 'ItemList';
    } else if (Object.prototype.hasOwnProperty.call(data, item)) {
      transformedData[item] = data?.[item];
    }
    if (item === 'notes') {
      transformedData[item] = 'notes';
    } else if (Object.prototype.hasOwnProperty.call(data, item)) {
      transformedData[item] = data?.[item];
    }
    if (
      item.includes('amount') ||
      item.includes('budget') ||
      item.includes('cost') ||
      item.includes('rate') ||
      item.includes('unitPrice') ||
      item.includes('plc_price')
    ) {
      // Never pass pre-formatted "₹…" into Intl — that becomes "₹NaN".
      const money = toFiniteMoneyNumber(data?.[item]);
      transformedData[item] =
        money != null ? formatIndianCurrency(money) : '₹ 0';
    }
    if (item.includes('plcRate')) {
      const value = data?.[item];
      const hasValue = value != null && value !== '';
      const defaultPercent = '0.0000 %';
      const defaultNumeric = '₹ 0.0000';
      transformedData[item] = hasValue
        ? data.mode === 'percent'
          ? `${Number(value).toLocaleString('en-IN', { minimumFractionDigits: 4, maximumFractionDigits: 4 })} %`
          : formatPLCRate(Number(value))
        : data.mode === 'percent' ? defaultPercent : defaultNumeric;
    }
    if (item.includes('status') && typeof data?.[item] === 'string') {
      transformedData[item] = `${capitaliseData(data?.[item])}`;
    }
    // Remove further
    if (item.includes('user_status') && !data?.[item]) {
      transformedData[item] = `Unpaid`;
    }
    if (item.includes('created_at')) {
      transformedData[item] = DateFormat(data?.['created_at']);
    }
    if (item.includes('accommodation-name')) {
      transformedData[item] = data.accommodation ? data?.accommodation['name'] : '';
    }
  });

  return transformedData;
}
